import Param from '../../param';

const param = new Param();

export default class YoutubeManager {
    constructor(){

        this.player;

        this.width = $("#"+param.youtube.domID).innerWidth();
        this.height = $("#"+param.youtube.domID).innerHeight();

        this.status = {
            load : false,
            play : false,
            pause : true,
            mute  : false,
        }

    }
    init(){

        this.player = new YT.Player(param.youtube.domID, {
            width: this.width,
            height: this.height,
            videoId: param.youtube.id,
            playerVars: {
                'autoplay' : 1,
                'html5': 1,
                'modestbranding': 1,
                'controls':0,
                'rel':0,
                'enablejsapi':1,
                'showinfo':0,
                'disablekb': 1
            },
            events: {
                'onReady':()=>{
                    this.status.load = true;
                },
                'onStateChange': this.onPlayerStateChange
            }
        });
        // this.player.playVideo();

    }
    onPlayerStateChange(event){

        console.log(event.data)

        if(event.data==0){
            $("#p-movie-console-play").removeClass("is-play");
            // $("#p-movie-console-sound").removeClass("is-unmute");
        }else if(event.data==1){
            $("#p-movie-console-play").addClass("is-play");
            // $("#p-movie-console-sound").addClass("is-unmute");
        }

        if(Useragnt.mobile&&event.data==2){/* SPは再生終了したら閉じる */

        }

    }
    resize(){

        if($("#"+param.youtube.domID)[0]){
            this.width = $("#"+param.youtube.domID).innerWidth();
            this.height = $("#"+param.youtube.domID).innerHeight();
        }



    }


}